export default __webpack_public_path__ + "images/WE.d8707b0.png";